// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"cb87de5f","85":"3a204a77"}[chunkId] + ".chunk.js";
};